module.exports = __webpack_public_path__ + "static/footer-fc25cca5713e2c1e420a077f8cc91d9e.jpg";